import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Switch from '@material-ui/core/Switch'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormGroup from '@material-ui/core/FormGroup'
import { WID } from '../../../constants/Language';
import Word from '../../../containers/Common/Word'

const styles = theme => ({
  card: {
    maxWidth: 680,
    boxShadow: 'none',
    margin: '0 auto',
  }
})

class BoardSettingsCard extends React.Component {
  state = {
    isVisibleNumber: true,
    isVisibleNextMove: true,
    isVisibleForbidden: true,
    isVisibleLastMoveMark: true,
  }

  componentDidMount() {
    const { isVisibleNumber, isVisibleNextMove, isVisibleForbidden, isVisibleLastMoveMark } = this.props.defaultValues
    this.setState({
      isVisibleNumber: isVisibleNumber === undefined ? true : isVisibleNumber,
      isVisibleNextMove: isVisibleNextMove === undefined ? true : isVisibleNextMove,
      isVisibleForbidden: isVisibleForbidden === undefined ? true : isVisibleForbidden,
      isVisibleLastMoveMark: isVisibleLastMoveMark === undefined ? true : isVisibleLastMoveMark,
    })
  }

  handleClickSwitch = (name) => (event) => {
    this.props.handleClickSwitch({ [name]: event.target.checked })
    this.setState({ [name]: event.target.checked })
  }

  render() {
    const { classes } = this.props
    const { isVisibleNumber, isVisibleNextMove, isVisibleForbidden, isVisibleLastMoveMark } = this.state
    return (
      <Card className={classes.card}>
        <CardHeader title={<Word wid={WID.RENJU_BOARD_SETTINGS_CARD.TITLE}/>}/>
        <CardContent>
          <FormGroup>
            <FormControlLabel
              control={<Switch checked={isVisibleNumber} value={'isVisibleNumber'} color='primary' onChange={this.handleClickSwitch('isVisibleNumber')}/>}
              label={<Word wid={WID.RENJU_BOARD_SETTINGS_CARD.NUMBER_OF_MOVE}/>}
            />
            <FormControlLabel
              control={<Switch checked={isVisibleForbidden} value={'isVisibleForbidden'} color='primary' onChange={this.handleClickSwitch('isVisibleForbidden')}/>}
              label={<Word wid={WID.RENJU_BOARD_SETTINGS_CARD.FORBIDDEN_MOVE_MARK}/>}
            />
            <FormControlLabel
              control={<Switch checked={isVisibleNextMove} value={'isVisibleNextMove'} color='primary' onChange={this.handleClickSwitch('isVisibleNextMove')}/>}
              label={<Word wid={WID.RENJU_BOARD_SETTINGS_CARD.NEXT_MOVE_MARK}/>}
            />
            <FormControlLabel
              control={<Switch checked={isVisibleLastMoveMark} value={'isVisibleLastMoveMark'} color='primary' onChange={this.handleClickSwitch('isVisibleLastMoveMark')}/>}
              label={<Word wid={WID.RENJU_BOARD_SETTINGS_CARD.LAST_MOVE_MARK}/>}
            />
          </FormGroup>
        </CardContent>
      </Card>
    )
  }
}

export default withStyles(styles, { withTheme: true })(BoardSettingsCard)



// WEBPACK FOOTER //
// ./src/Pages/Settings/components/BoardSettingsCard.js